import { atom, useRecoilValue } from 'recoil'
export type FolderType = {
    id: number | null
    folderName_th: string | null
    folderName_en: string | null
    submittedID: number | null
    submittedStatusID?: number
    isLastProcess?: boolean
    submittedTypeID?: number
}
export type TabSelectedType = {
    id: number | null
    nameTH: string | null
    nameEN: string | null
    stepID: number | null
}
export type appFolderAndTabStoreType = {
    folderList: Array<FolderType>
    folderSelected: FolderType
    // folderRenderList: any[]
    tabSelected: TabSelectedType
    tabRenderList: TabRenderListType[]
    tabDirty: boolean
    tabIndexSelected: number | null
    callbackDirty?: (tabIndex?: number, newTabSelected?: TabSelectedType, isFolder?: boolean) => void
}
export type TabRenderListType = { id: number; nameTH: string; nameEN: string; stepID: number }
export const appFolderAndTabStore = atom<appFolderAndTabStoreType>({
    key: 'appFolderAndTabStore',
    default: {
        folderList: [],
        folderSelected: {
            id: null,
            folderName_th: null,
            folderName_en: null,
            submittedID: null,
            isLastProcess: false,
        },
        tabSelected: {
            id: null,
            nameTH: null,
            nameEN: null,
            stepID: null,
        },
        tabIndexSelected: 0,
        tabRenderList: [],
        tabDirty: false,
        callbackDirty: undefined,
    },
})

const useAppFolderAndTabStore = () => {
    const appFolderAndTabState = useRecoilValue(appFolderAndTabStore)
    return {
        ...appFolderAndTabState,
    }
}

export default useAppFolderAndTabStore
